"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
class SmallCenteredLayout extends react_1.default.Component {
    render() {
        const { children } = this.props;
        return (react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center" },
            react_1.default.createElement(reactstrap_1.Col, { sm: "10", md: "8", lg: "6" }, children)));
    }
}
exports.SmallCenteredLayout = SmallCenteredLayout;
//# sourceMappingURL=SmallCenteredLayout.js.map